import { FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { IApplicationFormIndex, IHttpResponse } from '@boldpenguin/sdk-types';
import { Observable } from 'rxjs';
import { ISearchInputs } from 'src/app/models/application-form/search-form.model';
import { FormGroupStringType } from 'src/app/models/shared/shared-types';

export abstract class ApplicationSearchAbstractService {
  abstract get isSearchFormReady$(): Observable<boolean>;
  abstract set isSearchFormReady$(status: boolean);
  abstract get areSearchLoading$(): Observable<boolean>;
  abstract get searchFilters(): FormGroup<FormGroupStringType>;
  abstract get filterOption(): ISearchInputs[];
  abstract set sort(sort: Sort);
  abstract set page(page: PageEvent);
  abstract get searchResult$(): Observable<IHttpResponse<[IApplicationFormIndex]>>;
  abstract getApplicationForms(): void;
}
